import { ChangeEvent, FormEvent, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCreateProcess, useGetOrganizations } from '../../api/process'
import { Organization, TRANSLATE } from '../../types/organization'
import { Box, Grid, MenuItem, Paper, TextField } from '@mui/material'
import Button from '@mui/material/Button'

interface Props {
  className?: string
}

export default function NewProcessForm({ className }: Props) {
  const createProcess = useCreateProcess()
  const orgRef = useRef<HTMLSelectElement>(null)
  const numberRef = useRef<HTMLInputElement>(null)
  const descriptionRef = useRef<HTMLInputElement>(null)
  const performaRef = useRef<HTMLInputElement>(null)
  const orderRef = useRef<HTMLInputElement>(null)
  const weightRef = useRef<HTMLInputElement>(null)
  const navigate = useNavigate()
  const [selectedOrg, setSelectedOrg] = useState<Organization>(Organization.AFAGHTEL)
  const { data: orgs } = useGetOrganizations()

  async function submitForm(e: FormEvent) {
    e.preventDefault()
    await createProcess.mutateAsync({
      number: numberRef.current?.value,
      organization: selectedOrg,
      weight: weightRef.current?.value,
      performaNumber: performaRef.current?.value,
      orderNumber: orderRef.current?.value,
      description: descriptionRef.current?.value,
    })
  }

  useEffect(() => {
    if (createProcess.isSuccess) {
      navigate('/')
    }
  }, [createProcess.isSuccess])

  const organizationNumber = () => {
    return +(orgs?.find((o) => o.organization === selectedOrg)?.count ?? 0) + 1
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Box component="form" onSubmit={submitForm}>
        <Grid container spacing={1}>
          <Grid item xs={6} lg={3}>
            <TextField
              select
              fullWidth
              label="شرکت"
              type="password"
              error={createProcess.isError}
              inputRef={orgRef}
              onChange={(e: ChangeEvent) =>
                setSelectedOrg(
                  (e as ChangeEvent<HTMLSelectElement>).target.value as Organization
                )
              }
            >
              {orgs?.map((org) => (
                <MenuItem value={org.organization}>
                  {TRANSLATE[org.organization]}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6} lg={1}>
            <TextField
              label="شماره"
              type="number"
              fullWidth
              error={createProcess.isError}
              inputRef={numberRef}
              value={organizationNumber() ?? 1}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12} lg={8}>
            <TextField
              label="توضیح"
              type="text"
              fullWidth
              error={createProcess.isError}
              inputRef={descriptionRef}
            />
          </Grid>
          <Grid item xs={6} lg={4}>
            <TextField
              label="شماره پیش‌فاکتور"
              type="text"
              fullWidth
              error={createProcess.isError}
              inputRef={performaRef}
            />
          </Grid>
          <Grid item xs={6} lg={4}>
            <TextField
              label="شماره ثبت سفارش"
              type="text"
              fullWidth
              error={createProcess.isError}
              inputRef={orderRef}
            />
          </Grid>
          <Grid item xs={6} lg={4}>
            <TextField
              fullWidth
              label="وزن (کیلوگرم)"
              type="number"
              error={createProcess.isError}
              inputRef={weightRef}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              type="submit"
              sx={{ mt: 3 }}
              disabled={createProcess.isLoading}
            >
              ایجاد
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  )
}
